module.exports = __webpack_public_path__ + "static/media/mdcblack150.8c28a302.png";